
import axios from "axios";
import { defineComponent } from "vue";
import ModalCom1 from "@/components/ModalCom1.vue";

export default defineComponent({
  props: {
    date: String,
    spa: String,
    conWidth: Number,
    rule2: String,
  },
  components: {
    ModalCom1,
  },
  data() {
    return {
      columns: [],
      tableItem: [],
      tableHeight: 500,
      dataLoading: false,
      commSpa: "",
      commName: "",
      activeFieldNames: [
        "image",
        "name",
        "work_time",
        "week",
        "price",
        "height",
        "weight",
        "cup",
        "info",
        "ex",
      ],
      columnOrder: [
        "image",
        "name",
        "work_time",
        "week",
        "price",
        "height",
        "weight",
        "cup",
        "info",
        "ex",
      ],
    };
  },
  methods: {
    moveColumnUp(originalIndex: number) {
      if (originalIndex > 2) {
        const list = [...this.columnOrder];
        const item = list.splice(originalIndex, 1)[0];
        list.splice(originalIndex - 1, 0, item);
        this.columnOrder = list;
      }
    },
    moveColumnDown(originalIndex: number) {
      if (originalIndex >= 2 && originalIndex < this.columnOrder.length - 1) {
        const list = [...this.columnOrder];
        const item = list.splice(originalIndex, 1)[0];
        list.splice(originalIndex + 1, 0, item);
        this.columnOrder = list;
      }
    },
    selectSpa(spaName: string) {
      if (!spaName) return;

      this.dataLoading = true;
      var url = "/php/spa_table.php";

      axios
        .post(url, {
          action: "selectWork",
          table_name: spaName,
        })
        .then((res) => {
          const list = res.data || [];

          this.tableItem = list.map((item: any) => {
            // 安全處理圖片 URL 拼接，避免重複串接
            let imgUrl = item.image || "";
            if (imgUrl && !imgUrl.startsWith("http")) {
              imgUrl = "https://imgf.gg9453.com/images/spa_daily/" + imgUrl;
            }

            let ex = "";
            if (item.music === "true") ex += "、送音樂";
            if (item.bento) ex += "、套餐" + item.bento;
            ex = ex.startsWith("、") ? ex.substring(1) : ex;

            let info = item.info || "";
            if (item.name_his) {
              info = info + "<br>" + item.name_his;
            }

            let week = "";
            if (item.w1) week += "一" + item.w1 + "<br>";
            if (item.w2) week += "二" + item.w2 + "<br>";
            if (item.w3) week += "三" + item.w3 + "<br>";
            if (item.w4) week += "四" + item.w4 + "<br>";
            if (item.w5) week += "五" + item.w5 + "<br>";
            if (item.w6) week += "六" + item.w6 + "<br>";
            if (item.w7) week += "日" + item.w7 + "<br>";

            return {
              ...item,
              image: imgUrl,
              ex: ex,
              info: info,
              week: week,
            };
          });

          this.$nextTick(() => {
            const elTable: any = this.$refs.elTable;
            if (elTable) elTable.clearSort();
          });
        })
        .catch((error) => {
          console.error("載入工作班表失敗:", error);
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    tableRowStyle() {
      return {};
    },
    format1(scope: any) {
      var result = "";
      if (1 == scope.cellIndex && "true" == scope.row.day_push) {
        result +=
          '<img src="https://imgf.gg9453.com/images/hot.png" height="30" width="60"><br>';
      }
      if (1 == scope.cellIndex && "true" == scope.row.is_new) {
        result +=
          '<img src="https://imgf.gg9453.com/images/new2.png" height="30" width="60"><br>';
      }
      return result;
    },
    doButton(spa1: string, name1: string) {
      this.commSpa = spa1;
      this.commName = name1;
    },
    initColumns() {
      if (window.innerWidth < 600) {
        this.columns = [
          { prop: "image", label: "照片", show: true, fixed: "left", width: "65px" },
          {
            prop: "name",
            label: "姓名",
            show: false,
            sortable: true,
            fixed: "left",
            width: "85px",
          },
          {
            prop: "work_time",
            label: "可約時段",
            show: false,
            sortable: true,
            width: "120px",
          },
          {
            prop: "week",
            label: "當周報班",
            show: false,
            sortable: false,
            html: true,
            width: "150px",
          },
          { prop: "price", label: "台費", show: false, sortable: true, width: "70px" },
          { prop: "height", label: "身高", show: false, sortable: true, width: "70px" },
          { prop: "weight", label: "體重", show: false, sortable: true, width: "70px" },
          { prop: "cup", label: "罩杯", show: false, sortable: true, width: "70px" },
          {
            prop: "info",
            label: "介紹",
            show: false,
            sortable: true,
            html: true,
            width: "300px",
          },
          {
            prop: "ex",
            label: "額外服務",
            show: false,
            sortable: true,
            html: true,
            width: "200px",
          },
        ];
      } else {
        this.columns = [
          { prop: "image", label: "照片", show: true, fixed: "left", width: "200px" },
          {
            prop: "name",
            label: "姓名",
            show: false,
            sortable: true,
            fixed: "left",
            width: "120px",
          },
          {
            prop: "work_time",
            label: "可約時段",
            show: false,
            sortable: true,
            width: "200px",
          },
          {
            prop: "week",
            label: "當周報班",
            show: false,
            sortable: false,
            html: true,
            width: "150px",
          },
          { prop: "price", label: "台費", show: false, sortable: true, width: "90px" },
          { prop: "height", label: "身高", show: false, sortable: true, width: "90px" },
          { prop: "weight", label: "體重", show: false, sortable: true, width: "90px" },
          { prop: "cup", label: "罩杯", show: false, sortable: true, width: "90px" },
          {
            prop: "info",
            label: "介紹",
            show: false,
            sortable: true,
            html: true,
            width: "330px",
          },
          {
            prop: "ex",
            label: "額外服務",
            show: false,
            sortable: true,
            html: true,
            width: "200px",
          },
        ];
      }
    },
  },
  created() {
    this.tableHeight = Math.max(window.innerHeight - 300, 500);
    this.initColumns();
  },
  mounted() {
    if (this.spa) {
      this.selectSpa(this.spa);
    }
  },
  watch: {
    // 嚴格比對變更，防範重複/無效觸發 HTTP 請求
    spa(val, oldVal) {
      if (val && val !== oldVal) {
        this.selectSpa(val);
      }
    },
  },
  computed: {
    visibleColumns(): any {
      const filtered = this.columns.filter((col: any) =>
        this.activeFieldNames.includes(col.prop)
      );

      return [...filtered].sort((a: any, b: any) => {
        const indexA = this.columnOrder.indexOf(a.prop);
        const indexB = this.columnOrder.indexOf(b.prop);
        const posA = indexA === -1 ? 999 : indexA;
        const posB = indexB === -1 ? 999 : indexB;
        return posA - posB;
      });
    },
  },
});
